import { Popover } from "@headlessui/react";
import { router } from "@inertiajs/react";
import React from "react";
import { BsExclamation } from "react-icons/bs";
import { IoFlashOutline } from "react-icons/io5";
import { TbSunrise } from "react-icons/tb";

import SimpleButton from "@/components/Buttons/SimpleButton";
import { CardRow, CardRowActions, CardRowCell, CardRowCells } from "@/components/CardRow";
import PowerPlantNameDisplay from "@/components/PowerPlantNameDisplay";
import Typography from "@/components/Typography";
import { PowerPlantCardProps } from "@/pages/manager/power-plants/types";

const PowerPlantCard: React.FC<PowerPlantCardProps> = ({
  id,
  name,
  energy,
  onClick,
  percentageLetters = true,
}) => {
  return (
    <CardRow>
      <CardRowCells
        className="grid w-[537px] shrink-0 grid-cols-[200px_137px_200px] items-center"
        dividerClassName="ml-[120px] mr-4"
      >
        <CardRowCell
          label="NOME"
          value={name}
          icon={<TbSunrise />}
          renderValue={(value) => <PowerPlantNameDisplay name={String(value)} />}
        />
        <CardRowCell label="CAPACIDADE INSTALADA" value={energy} icon={<IoFlashOutline />} />
      </CardRowCells>
      <CardRowActions className="mr-0 pr-0">
        {!percentageLetters && (
          <div className="flex items-center">
            <Popover>
              <Popover.Button>
                <BsExclamation className="rounded-full bg-yellow-400" size={24} />
              </Popover.Button>

              <Popover.Panel className="absolute right-6 z-50 w-64 rounded bg-gray-900 p-5 lg:w-96">
                <Typography variant="pLarge" color="white">
                  Esta usina ainda não possui uma carta de rateio
                </Typography>
              </Popover.Panel>
            </Popover>
          </div>
        )}
        <SimpleButton
          variant="simple"
          label="Rateio"
          onClick={() => router.visit(`/manager/power-plants/${id}/percentage-letters`)}
        />
        <SimpleButton variant="simple" label="Detalhes" onClick={onClick} />
      </CardRowActions>
    </CardRow>
  );
};

export default PowerPlantCard;
